/* image_type_asdm.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.7 20.5" preserveAspectRatio="none">
        <polygon class="foreground-gl" points="10.13 10.81 12.79 10.81 11.48 6.79 10.13 10.81"/>
        <path class="foreground-gl" d="M19.89.28H3A2.22,2.22,0,0,0,.74,2.51V18.08A2.32,2.32,0,0,0,3.05,20.4H19.71a2.52,2.52,0,0,0,2.51-2.52V2.62A2.33,2.33,0,0,0,19.89.28ZM14.31,15.39l-.82-2.31H9.4l-.77,2.31H5.85L10.28,3.65h2.48l4.38,11.74Z"/>
        </svg>
    `
};
